
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import StorySection from '../components/StorySection';
import SocialProof from '../components/SocialProof';
import ProductCard from '../components/ProductCard';
import { Product } from '../types';

interface HomeProps {
  addToCart: (p: Product) => void;
  products: Product[];
}

const Home: React.FC<HomeProps> = ({ addToCart, products }) => {
  const bestSellers = useMemo(() => {
    return products.filter(p => p.label?.toLowerCase() === 'best-seller');
  }, [products]);

  const promoProducts = useMemo(() => {
    return products.filter(p => p.originalPrice && p.originalPrice > p.price);
  }, [products]);

  return (
    <div className="overflow-x-hidden">
      <Hero />
      
      {/* Section Best-Sellers */}
      <section className="py-24 md:py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-20">
            <span className="text-[11px] uppercase tracking-[0.4em] text-brand-gold mb-4 block font-bold">
              Sélection Khamal
            </span>
            <h2 className="font-serif text-4xl md:text-5xl">Nos Best-Sellers</h2>
            <p className="mt-4 text-gray-400 font-light max-w-xl mx-auto italic">
              Les pièces les plus convoitées de notre catalogue.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-16">
            {(bestSellers.length > 0 ? bestSellers : products.slice(0, 4)).map((product) => (
              <ProductCard key={product.id} product={product} onAddToCart={addToCart} />
            ))}
          </div>
        </div>
      </section>

      {/* Section Promotions (Ventes Privées) */}
      {promoProducts.length > 0 && (
        <section className="py-24 md:py-32 bg-brand-cream/30">
          <div className="container mx-auto px-6">
            <div className="text-center mb-20">
              <span className="text-[11px] uppercase tracking-[0.4em] text-red-600 mb-4 block font-bold">
                Opportunités
              </span>
              <h2 className="font-serif text-4xl md:text-5xl italic">Ventes Privées</h2>
              <p className="mt-4 text-gray-400 font-light max-w-xl mx-auto">
                Une sélection exclusive de maroquinerie à prix privilégiés.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-16">
              {promoProducts.slice(0, 4).map((product) => (
                <ProductCard key={product.id} product={product} onAddToCart={addToCart} />
              ))}
            </div>
            
            <div className="mt-20 text-center">
              <Link to="/shop" className="text-[11px] uppercase tracking-[0.3em] font-bold border-b-2 border-brand-black pb-2 hover:text-brand-gold hover:border-brand-gold transition-all">
                Voir toutes les offres
              </Link>
            </div>
          </div>
        </section>
      )}

      <StorySection />
      
      <SocialProof />
    </div>
  );
};

export default Home;
